import {Grid, withStyles, withTheme, Button} from "@material-ui/core";
import * as PropTypes from "prop-types";
import style from "./styles";
import React from "react";
import {withFb} from '../../contexts/FbProvider';
import Badge from '@material-ui/core/Badge';

const DropButtonBuilder = (props) => {
    const { fieldSchema: schema, classes, /*form*/} = props;

    return <Grid item {...schema.props} {...(schema.sizes ?? {})} className={classes.dropButtonContainer}>
        <Badge overlap="rectangular"
               badgeContent={schema?.badge} color={'default'}
               className={classes.iconButtonBadge}
               anchorOrigin={{
                   vertical: 'bottom',
                   horizontal: 'right',
               }}>
            <Button type={schema.typeButton ?? 'button'} variant={'outlined'} onClick={schema.onClick}>{schema.label}</Button>
        </Badge>
    </Grid>;
};

DropButtonBuilder.propTypes = {
    classes: PropTypes.any,
    data: PropTypes.any
};

export default withTheme(withStyles(style)(withFb(DropButtonBuilder)));
